import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import Layout from "../../wrapper";
import { Grid } from "@mui/material";
import axios from "axios";
import Loader from "../../Layout/Loader";
import TextField from "../../Components/common/TextField";
import Table from "../../Components/common/tableWithBackEndPagination";
import withRoutes from "../../HOC/HocRoutes";
import MenuItem from "../../Components/common/MenuItem";
import Button from "../../Components/common/Button";
import instance from "../../axios";
import { logInUserInfo } from "../../Actions/Users";
import { toast } from "react-toastify";
import ConfirmDialoag from "../../Components/common/ConfirmDialoag";
import TicketHeader from "../../Components/CRC/TicketHeader";
import CreateTicketForm from "../../Components/CRC/CreateTicketForm";
import TaskView from "../../Components/CRC/TaskView";
import TaskList from "../../Components/CRC/TaskList";
import { useSelector } from "react-redux";

let source;

const entityOptions = [
  { name: "Vehicle", value: "vehicle" },
  { name: "Service", value: "service" },
  { name: "Account", value: "account" },
];

const serverOptions = [
  { name: "Dex", value: "dex" },
  { name: "Mac", value: "mac" },
];

const CRC = (props) => {
  const logInUser = useSelector((state) => state.logInUsers)
  const [filters, setFilters] = useState({
    currentStatus: "",
    searchText: "",
    from: "",
    to: "",
    contractNumber: "",
    assignTo:logInUser?.id||"",
  });

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    total: 0,
    hasNext: false
  });

  const [data, setData] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [viewTask, setViewTask] = useState(null);
  const [isShowCreateForm, setIsShowCreateForm] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [ticketComments, setTicketComments] = useState([]);




  const buildParams = (page) => ({
    page,
    limit: pagination.pageSize,
    ...(filters.currentStatus && { currentStatus: filters.currentStatus }),
    ...(filters.searchText && { search: filters.searchText }),
    ...(filters.from && { from: filters.from }),
    ...(filters.to && { to: filters.to }),
    ...(filters.contractNumber && { cn: filters.contractNumber }),
    ...(filters.assignTo && { assignTo: filters.assignTo })


  });


  const getData = useCallback(async (type) => {
    try {
      setIsLoading(true);

      let page = pagination.currentPage;

      if (type === "next") page += 1;
      if (type === "prev") page -= 1;
      if (type === "first") page = 1;
      if (type === "last") page = Math.ceil(pagination.total / pagination.pageSize);

      const res = await instance.get("/api/tickets/get", {
        params: buildParams(page)
      });

      setData(res.data || []);

      setPagination({
        currentPage: res.page,
        pageSize: res.pageSize,
        total: res.total,
        hasNext: res.hasNext
      });

    } catch (error) {
      if (error?.statusCode === "440") props.history?.push("/logout");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [filters, pagination.currentPage, pagination.pageSize, pagination.total]);



  useEffect(() => {
    getData();
  }, [filters]);


  const handleAddCloseForm = () => {
    setSelectedTask(null);
    setIsShowCreateForm((prev) => !prev);

    if (isShowCreateForm) {
      getData();
    }
  };



  const handleView = (item) => {
    setViewTask(item);
    getTicketComments(item)
    getTicketActivity(item)
  }
  const handleCloseView = () => setViewTask(null);

  const handleEdit = (item) => {
    setSelectedTask(item);
    setIsShowCreateForm(true);
    setViewTask(null)
  };


  const deleteTickets = async () => {
    try {
      await instance.delete(`/api/tickets/${selectedTask.id}`);
      toast.success("ticketDeleted")

      getData();

    } catch (err) {
      console.error(err);
    } finally {
      handleCloseDelete();
    }
  };

  const handleOpenDelete = (item) => {
    setSelectedTask(item);
    setIsDelete(true);
  };

  const handleCloseDelete = () => {
    setIsDelete(false);
    setSelectedTask(null);
  };


  const onSearch = (value) => {
    setFilters({
      currentStatus: value?.status || "",
      searchText: value?.searchText || "",
      from: value?.dateRange?.from || "",
      to: value?.dateRange?.to || "",
      contractNumber: value?.contractNumber || "",
      assignTo:value?.assignTo||"",
    });

    setPagination((prev) => ({
      ...prev,
      currentPage: 1
    }));
  };



const [isloadingComments,setIsloadingComments]=useState(false)
  // ticket against comments
  const getTicketComments = async (ticket) => {
    try {
      setIsloadingComments(true)
      const response = await instance.get(`/api/ticketcomments/get?ticketId=${ticket.id}`);
      setTicketComments(response);
      setIsloadingComments(false)


    } catch (error) {
      if (error?.statusCode === "440") props.history.push("/logout");
      console.error(error);
      setIsloadingComments(false)

    }
  };

  const createTicketComment = async (payload) => {
    try {
      const response = await instance.post(`/api/ticketcomments`, payload);
      toast.success("commentAdded")

      getTicketComments(viewTask)

    } catch (error) {
      if (error?.statusCode === "440") props.history.push("/logout");
      console.error(error);
    }
  };

  const updateTicketComment = async (payload) => {
    try {
      const response = await instance.put(`/api/ticketcomments/${payload.id}`, payload);
      toast.success("commentUpdated")

      getTicketComments(viewTask)

    } catch (error) {
      if (error?.statusCode === "440") props.history.push("/logout");
      console.error(error);
    }
  };

  const deleteTicketComment = async (deletedId) => {
    try {
      const response = await instance.delete(`/api/ticketcomments/${deletedId}`);
      toast.success("commentDeleted")
      getTicketComments(viewTask)

    } catch (error) {
      if (error?.statusCode === "440") props.history.push("/logout");
      console.error(error);
    }
  };
  const ticketAssignToUser = async (task, user) => {
    try {
      const payload = {
        ...task,
        assignTo: user?.id,
        attributes: {
          ...(task?.attributes || {}),
          assignUser: user,
          assignTo: user?.label || "",
        },
      };
      await instance.put(`/api/tickets/${task.id}`, payload);

      toast.success("User Assigned");
      getData();
    } catch (error) {
      console.error(error);
      toast.error("Assign failed");
    }
  };



  const [ticketActivity, setTickeActivity] = useState([])

  const getTicketActivity = async (ticket) => {
    try {
      const response = await instance.get(`/api/ticketlogs/get?ticketId=${ticket.id}`);
      setTickeActivity(response?.data || []);

    } catch (error) {
      if (error?.statusCode === "440") props.history.push("/logout");
      console.error(error);
    }
  };



  // search users 
  const [defaultUsersList, setDefaultUsersList] = useState([])
  const [isLoadingUsers, setIsLoadingUsers] = useState(false)
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);
  useEffect(() => {
    fetchUsersList();
  }, [debouncedSearch]);

  const fetchUsersList = async () => {
    try {
      setIsLoadingUsers(true)
      const fetchApi = `/api/users/get?userId=${logInUser.id}&all=true&page=1&limit=20&search=${debouncedSearch || ""}&userTypes=4`;

      const response = await instance.get(fetchApi);

      const users =
        response?.data?.map((acc) => ({
          id: acc?.entity?.id,
          label: acc?.entity?.name,
        })) || [];

      setDefaultUsersList(users);
    } catch (err) {
      console.error("Failed to fetch users", err);
    } finally {
      setIsLoadingUsers(false)
    }
  };

  const handleSearchUser = (value) => {
    setSearch(value)
  }

  if (!props.logInUser) {
    fetch(
      "/api/session?app=3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05",
      {
        headers: { Accept: "application/json; odata=verbose" },
      }
    )
      .then((response) => {
        if (response.ok) {
          response.json().then((res) => {
            if (res.status === "success") {
              let userInfo = res.data;
              props.setActiveLanguage(
                userInfo?.attributes?.lang || "en"
              );
              props.dispatch(logInUserInfo(userInfo));
            } else if (res?.statusCode === "440") {
              window.location.replace("/login");
            } else if (res.statusCode) {
              var err = res?.message.split(":");
              err[1] = err[1].replace(")", "");

              toast.error(props.translate(err[1]));
              props.navigate("/login");
            }
          });
        } else {
          props.navigate("/login");
          throw response;
        }
      })
      .catch((e) => {
        toast.error("somethingWentWrong");
      });
    return null;
  };
  return (
    <Layout {...props} isLoadData={isLoading}>
      <div className="" style={{ marginTop: "1rem", backgroundColor: "white" }}>

        {!viewTask && (
          <TicketHeader
            translate={props.translate}
            isShowCreateForm={isShowCreateForm}
            handleAddCloseForm={handleAddCloseForm}
            onSearch={onSearch}
            defaultUsersList={defaultUsersList}
            handleSearchUser={handleSearchUser}
            logInUser={logInUser}
          />
        )}

        {isShowCreateForm ? (
          <CreateTicketForm
            {...props}
            handleAddCloseForm={handleAddCloseForm}
            selectedTask={selectedTask}
          />
        ) : viewTask ? (
          <TaskView
            task={viewTask}
            onClose={handleCloseView}
            handleEdit={handleEdit}
            ticketAssignToUser={ticketAssignToUser}
            translate={props.translate}
            ticketComments={ticketComments}
            createTicketComment={createTicketComment}
            updateTicketComment={updateTicketComment}
            deleteTicketComment={deleteTicketComment}
            ticketActivity={ticketActivity}
            isloadingComments={isloadingComments}
          />
        ) : (
          <>
            {isLoading ? (
              <Loader />
            ) : (
              <TaskList
                translate={props.translate}
                tasks={data}
                handleEdit={handleEdit}
                handleView={handleView}
                handleDelete={handleOpenDelete}
                pagination={pagination}
                onPageChange={getData}
                logInUser={props.logInUser}
                defaultUsersList={defaultUsersList}
                handleSearchUser={handleSearchUser}
                searchUserValue={search}
                setSearchUserValue={setSearch}
                isLoadingUsers={isLoadingUsers}
                ticketAssignToUser={ticketAssignToUser}
              />
            )}
          </>
        )}

        {isDelete && (
          <ConfirmDialoag
            onCancel={handleCloseDelete}
            onOk={deleteTickets}
            title={props.translate("areYouWantToDelete")}
          >
            {selectedTask?.name}
          </ConfirmDialoag>
        )}

      </div>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  accounts: state.accounts,
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers,
  themecolors: state.themecolors,
});

export default connect(mapStateToProps)(withRoutes(CRC));